
<div>
    <div class="row ">
        <div class="col pl-3">
            <h4 class="mb-0 font-header-1 mb-2" style="font-weight: 700;">Manage Services</h4>
        </div>
    </div>
    <div *ngIf="global.globalAgencyId==null || global.globalAgencyId==undefined ||global.globalAgencyId=='00000000-0000-0000-0000-000000000000' || global.globalAgencyId=='' ">
        <div class="row mt-4 ">
            <div class="col ">
                <div widget class="card border-0 box-shadow">
                    <div class="card-body  widget-body pt-2">
                        <div class="text-center text-danger">
                            <label class="font-red animate-charcter"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select
                                agency to view
                                details</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row mb-2 mt-4"
        *ngIf="global.globalAgencyId!=null && global.globalAgencyId!='' && global.globalAgencyId!=undefined &&  global.globalAgencyId!='00000000-0000-0000-0000-000000000000'">
        <div class="col ">
            <div widget class="card border-0 box-shadow" style="min-height: 500px;">
                <div class="card-body  widget-body pt-2">
                    <section id="tabs" class="project-tab">
                        <div>
                            <div class="row">
                                <div class="col-md-12">
                                    <nav>
                                        <div class="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
                                            <!-- <a class="nav-item nav-link active" id="nav-ServiceGroup-tab"
                                                data-bs-toggle="tab" href="#nav-ServiceGroup" role="tab"
                                                aria-controls="nav-ServiceGroup" aria-selected="true"
                                                (click)="getServiceGroup();selecttab('ServiceGroup')">Service Group</a> -->
                                            <a class="nav-item nav-link active" id="nav-Service-tab" data-bs-toggle="tab"
                                                href="#nav-Service" role="tab" aria-controls="nav-Service"
                                                aria-selected="true"
                                                (click)="getService();selecttab('Service')">Service</a>
                                            <a class="nav-item nav-link " id="nav-Activity-tab" data-bs-toggle="tab"
                                                href="#nav-Activity" role="tab" aria-controls="nav-Activity"
                                                aria-selected="false"
                                                (click)="getActivity();selecttab('Activity')">Activity</a>
                                            <!-- <a class="nav-item nav-link " id="nav-serviceandActivity-tab"
                                                data-bs-toggle="tab" href="#nav-serviceandActivity" role="tab"
                                                aria-controls="nav-serviceandActivity" aria-selected="false"
                                                (click)="getServiceActivity();getServiceTypeSatus();selecttab('Serviceactivity')">Service
                                                and Activity</a> -->
                                            <!-- <a class="nav-item nav-link " id="nav-ServicePaylocity-tab"
                                                data-bs-toggle="tab" href="#nav-ServicePaylocity" role="tab"
                                                aria-controls="nav-ServicePaylocity" aria-selected="false"
                                                (click)="getPaylocity();selecttab('ServicePaylocity')">Service
                                                Paylocity</a>
                                            <a class="nav-item nav-link " id="nav-ServiceGrpMap-tab" data-bs-toggle="tab"
                                                href="#nav-ServiceGrpMap" role="tab" aria-controls="nav-ServiceGrpMap"
                                                aria-selected="false"
                                                (click)="getServiceGroupMapping();selecttab('ServiceGrpMap')">Service &
                                                ServiceGroup
                                                Mapping</a> -->
                                        </div>
                                        <div class="tab-content mt-3" id="nav-tabContent">
                                           
                                            <!-- Service Tab -->
                                            <div class="tab-pane  fade show active" id="nav-Service" role="tabpanel"
                                                aria-labelledby="nav-Service-tab">
                                                <div class="row no-gutters aligned_form">
                                                    <div class="col-lg-2 col-md-4 col-sm-2 col-xs-5  ml-0 text-left">
                                                        <button *ngIf="fp.servicecreate" type="button"
                                                            class="btn blue-btn btn-sm" data-bs-toggle="modal"
                                                            data-bs-target="#modal" (click)="Createupdate('new')"
                                                            [disabled]="global.globalAgencyId == '00000000-0000-0000-0000-000000000000'">Add
                                                            Service</button>&nbsp;
                                                    </div>

                                                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-5 ml-0 aligned_form">
                                                        <label class="col-lg-4">Select Filter </label>&nbsp;
                                                        <!-- <select [(ngModel)]="filterSelect_service" class="form-control"
                                                            [disabled]="global.globalAgencyId == '00000000-0000-0000-0000-000000000000'"
                                                            (ngModelChange)="serviceFilter(filterSelect_service)">
                                                            <option value="1">Active</option>
                                                            <option value="2">Inactive</option>
                                                            <option value="0">ALL</option>

                                                        </select>&nbsp; -->

                                                        <select style="font-weight: 600;" class="form-control" id="servicestatusLid"
                                                        [disabled]="global.globalAgencyId == '00000000-0000-0000-0000-000000000000'"
                                                          
                                                        [(ngModel)]="filterSelect_service"(ngModelChange)="serviceFilter(filterSelect_service)">
                                                        <option></option>
                                                        <option [value]=i.id *ngFor="let i of FilterStatusDropDown">{{i.lovName}}</option>
                                                    </select>
                                                    </div>
                                                    <!--------------------------------Add QP services button 11-11-2021---------------------------------->
                                                    <div class="col-lg-4 col-md-4 col-sm-2 col-xs-5  ml-0">
                                                        <!-- <button type="button" class="btn blue-btn btn-sm"
                                                            (click)="createNewQPService('new')"
                                                            [disabled]="global.globalAgencyId=='00000000-0000-0000-0000-000000000000'" data-bs-toggle="modal"
                                                            data-bs-target="#AssignQPmodal">
                                                            Assign QP services
                                                        </button> -->
                                                    </div>


                                                    <div class="col-lg-2 col-md-4 col-sm-4 col-xs-5  mt-1">
                                                        <button type="button" class="btn blue-btn btn-sm"
                                                            style="float:right" (click)="Refresh()"
                                                            [disabled]="global.globalAgencyId == '00000000-0000-0000-0000-000000000000'">
                                                            <i class="fa fa-repeat"> </i>Refresh
                                                        </button>
                                                    </div>
                                                </div>
                                                <hr>
                                                <div style="width: 100%;">
                                                    <div *ngIf="global.globalAgencyId=='00000000-0000-0000-0000-000000000000'"
                                                        class="text-center text-danger center-block">
                                                        <label class="font-red"><i
                                                                class="fa fa-info-circle fa-lg"></i>&nbsp;Select agency
                                                            to
                                                            view details</label>
                                                    </div>
                                                    <ejs-grid #grid [dataSource]='GridDataList | async' [allowResizing]='true'
                                                          [allowSorting]='true'
                                                        allowPaging='true' [allowFiltering]='true'
                                                        [pageSettings]='initialPage' [filterSettings]='filterOptions'
                                                        (dataStateChange)='dataStateChange($event)'
                                                        (actionBegin)="onActionComplete($event)"
                                                        [showColumnChooser]='true' (resizeStop)="onResize($event)">
                                                        <e-columns>
                                                            <e-column minWidth=100 headerText="Actions" uid="action"
                                                                textAlign="center" [showInColumnChooser]='false'>
                                                                <ng-template #template let-data>
                                                                    <button *ngIf="fp.serviceupdate"
                                                                        class="btn btn-edit-table" data-bs-toggle="modal"
                                                                        data-bs-target="#modal"
                                                                        (click)="Createupdate('edit');selectDetails(data)"><i
                                                                            class="fa fa-edit"></i></button>&nbsp;
                                                                    <button *ngIf="fp.servicedelete"
                                                                        class="btn btn-delete-table" data-bs-toggle="modal"
                                                                        data-bs-target="#deleteStatusmodal"
                                                                        (click)="selectDetails(data)"><i
                                                                            class="fa fa-trash"></i></button>
                                                                </ng-template>
                                                            </e-column>
                                                            <e-column minWidth=100 field="masterServiceCode"
                                                                headerText="Code" type="string">
                                                                <ng-template #filterTemplate let-data>
                                                                    <ejs-maskedtextbox placeholder="Enter the value">
                                                                    </ejs-maskedtextbox>
                                                                </ng-template>
                                                            </e-column>
                                                            <e-column minWidth=175 field="masterServiceName"
                                                                headerText="Name" type="string">
                                                                <ng-template #filterTemplate let-data>
                                                                    <ejs-maskedtextbox placeholder="Enter the value">
                                                                    </ejs-maskedtextbox>
                                                                </ng-template>
                                                            </e-column>
                                                            <e-column minWidth=100 field="masterServiceModifier1"
                                                                headerText="Modifier 1" type="string">
                                                                <ng-template #filterTemplate let-data>
                                                                    <ejs-maskedtextbox placeholder="Enter the value">
                                                                    </ejs-maskedtextbox>
                                                                </ng-template>
                                                            </e-column>
                                                            <e-column minWidth=100 field="masterServiceModifier2"
                                                                headerText="Modifier 2" type="string">
                                                                <ng-template #filterTemplate let-data>
                                                                    <ejs-maskedtextbox placeholder="Enter the value">
                                                                    </ejs-maskedtextbox>
                                                                </ng-template>
                                                            </e-column>
                                                            <e-column minWidth=100 field="masterServiceModifier3"
                                                                headerText="Modifier 3" type="string">
                                                                <ng-template #filterTemplate let-data>
                                                                    <ejs-maskedtextbox placeholder="Enter the value">
                                                                    </ejs-maskedtextbox>
                                                                </ng-template>
                                                            </e-column>
                                                            <e-column minWidth=100 field="masterServiceModifier4"
                                                                headerText="Modifier 4" type="string">
                                                                <ng-template #filterTemplate let-data>
                                                                    <ejs-maskedtextbox placeholder="Enter the value">
                                                                    </ejs-maskedtextbox>
                                                                </ng-template>
                                                            </e-column>
                                                            <e-column minWidth=175 field="serviceDescription"
                                                                headerText="Description" type="string">
                                                                <ng-template #filterTemplate let-data>
                                                                    <ejs-maskedtextbox placeholder="Enter the value">
                                                                    </ejs-maskedtextbox>
                                                                </ng-template>
                                                            </e-column>
                                                            <e-column minWidth=100 field="ratio" headerText="Ratio"
                                                                type="number"></e-column>
                                                            <e-column minWidth=100 field="netRate" headerText="Net Rate"
                                                                type="string" [allowFiltering]='false'><ng-template
                                                                    #filterTemplate let-data>
                                                                    <ejs-maskedtextbox placeholder="Enter the value">
                                                                    </ejs-maskedtextbox>
                                                                </ng-template></e-column>
                                                            <e-column minWidth=100 field="unitrate"
                                                                headerText="Unit Rate" type="string"
                                                                [allowFiltering]='false'><ng-template #filterTemplate
                                                                    let-data>
                                                                    <ejs-maskedtextbox placeholder="Enter the value">
                                                                    </ejs-maskedtextbox>
                                                                </ng-template></e-column>
                                                            <e-column minWidth=100 field="statusName" headerText="Status" uid="status">
                                                                <ng-template #filterTemplate let-data>
                                                                    <!-- {{data.statusLid== 1 ? "Active" : "Inactive"}} -->
                                                                    <!-- <label *ngIf="data.statusLid == 1">Active</label>
                                                    <label *ngIf="data.statusLid != 1">Inactive</label> -->
                                                                </ng-template>
                                                            </e-column>

                                                            <e-column width="50" [showInColumnChooser]='false'>
                                                                <ng-template #headerTemplate let-data>
                                                                    <div class="d-none d-lg-block">
                                                                        <span id='show' (click)='show()'><i
                                                                                class="fa fa-cog fa-lg"
                                                                                aria-hidden="true">
                                                                            </i></span>
                                                                    </div>
                                                                </ng-template>
                                                            </e-column>
                                                        </e-columns>
                                                    </ejs-grid>
                                                    <div *ngIf="ServiceDataList.length == 0  &&  global.globalAgencyId!='00000000-0000-0000-0000-000000000000'"
                                                        class="text-center" style="color:red">
                                                        <p>No data available</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- Activity -->
                                            <div class="tab-pane fade show" id="nav-Activity" role="tabpanel"
                                                aria-labelledby="nav-Activity-tab">
                                                <div class="row no-gutters aligned_form">
                                                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-5  ml-0 text-left">
                                                        <button type="button" class="btn blue-btn btn-sm"
                                                            data-bs-toggle="modal" data-bs-target="#Activitymodal"
                                                            (click)="CreateupdateActivity('new')"
                                                            [disabled]="global.globalAgencyId == '00000000-0000-0000-0000-000000000000'"
                                                            *ngIf="fp.activitycreate">Add Activity</button>&nbsp;
                                                    </div>
                                                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-5 ml-0 aligned_form">
                                                        <label class="col-lg-4">Select Filter</label>&nbsp;
                                                        <!-- <select [(ngModel)]="filterSelect_service" class="form-control"
                                                            [disabled]="global.globalAgencyId == '00000000-0000-0000-0000-000000000000'"
                                                            (ngModelChange)="ActivityFilter(filterSelect_service)">
                                                            <option value="1">Active</option>
                                                            <option value="2">Inactive</option>
                                                            <option value="0">ALL</option>
                                                        </select> -->
                                                        <select style="font-weight: 600;" class="form-control" id="servicestatusLid"
                                                        [disabled]="global.globalAgencyId == '00000000-0000-0000-0000-000000000000'"
                                                          
                                                        [(ngModel)]="filterSelect_service"(ngModelChange)="ActivityFilter(filterSelect_service)">
                                                        <option></option>
                                                        <option [value]=i.id *ngFor="let i of FilterStatusDropDown">{{i.lovName}}</option>
                                                    </select>
                                                    </div>
                                                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-5 ml-1">
                                                        <button type="button" class="btn blue-btn btn-sm"
                                                            (click)="RefreshActivity()"
                                                            [disabled]="global.globalAgencyId == '00000000-0000-0000-0000-000000000000'">
                                                            <i class="fa fa-repeat"> </i>Refresh
                                                        </button>
                                                    </div>
                                                </div>
                                                <hr>
                                                <div style="width: 100%;">
                                                    <div *ngIf="global.globalAgencyId=='00000000-0000-0000-0000-000000000000'"
                                                        class="text-center text-danger center-block">
                                                        <label class="font-red"><i
                                                                class="fa fa-info-circle fa-lg"></i>&nbsp;Select agency
                                                            to
                                                            view details</label>
                                                    </div>
                                                    <ejs-grid #gridactivity [dataSource]='GridDataList | async'
                                                        [allowResizing]='true'  
                                                        [allowSorting]='true' allowPaging='true' [allowFiltering]='true'
                                                        [pageSettings]='initialPage' [filterSettings]='filterOptions'
                                                        (dataStateChange)='dataStateChange1($event)'
                                                        (actionBegin)="onActionComplete1($event)"
                                                        [showColumnChooser]='true'
                                                        (resizeStop)="onResizeActivity($event)">
                                                        <e-columns>
                                                            <e-column minWidth=100 headerText="Actions" uid="action"
                                                                textAlign="center" [showInColumnChooser]='false'>
                                                                <ng-template #template let-data>
                                                                    <button class="btn btn-edit-table"
                                                                        *ngIf="fp.activityupdate" data-bs-toggle="modal"
                                                                        data-bs-target="#Activitymodal"
                                                                        (click)="CreateupdateActivity('edit');selectActivityDetails(data)"><i
                                                                            class="fa fa-edit"></i></button>&nbsp;
                                                                    <button class="btn btn-delete-table"
                                                                        *ngIf="fp.activitydelete" data-bs-toggle="modal"
                                                                        data-bs-target="#deleteActivitymodal"
                                                                        (click)="selectActivityDetails(data)"><i
                                                                            class="fa fa-trash"></i></button>
                                                                </ng-template>
                                                            </e-column>
                                                            <e-column minWidth=100 field="masterActivityCode"
                                                                headerText="Code" type="string">
                                                                <ng-template #filterTemplate let-data>
                                                                    <ejs-maskedtextbox placeholder="Enter the value">
                                                                    </ejs-maskedtextbox>
                                                                </ng-template>
                                                            </e-column>
                                                            <e-column minWidth=100 field="masterActivityName"
                                                                headerText="Name" type="string">
                                                                <ng-template #filterTemplate let-data>
                                                                    <ejs-maskedtextbox placeholder="Enter the value">
                                                                    </ejs-maskedtextbox>
                                                                </ng-template>
                                                            </e-column>
                                                            <e-column minWidth=100 headerText="Status" uid="status">
                                                                <ng-template #template let-data>
                                                                    {{data.statusLid== 1 ? "Active" : "Inactive"}}
                                                                </ng-template>
                                                            </e-column>

                                                            <e-column width="50" [showInColumnChooser]='false'>
                                                                <ng-template #headerTemplate let-data>
                                                                    <div class="d-none d-lg-block">
                                                                        <span id='show' (click)='showactivity()'><i
                                                                                class="fa fa-cog fa-lg"
                                                                                aria-hidden="true">
                                                                            </i></span>
                                                                    </div>
                                                                </ng-template>
                                                            </e-column>
                                                        </e-columns>
                                                    </ejs-grid>
                                                    <div *ngIf="DataActivityList.length == 0  &&  global.globalAgencyId!='00000000-0000-0000-0000-000000000000'"
                                                        class="text-center" style="color:red">
                                                        <p>No data available</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- Service & Activity -->
                                            <div class="tab-pane fade show" id="nav-serviceandActivity" role="tabpanel"
                                                aria-labelledby="nav-serviceandActivity-tab">

                                                <div class="row no-gutters aligned_form">
                                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6  ml-0 text-left">
                                                        <button type="button" class="btn blue-btn btn-sm"
                                                            data-bs-toggle="modal" data-bs-target="#ServiceActivitymodal"
                                                            (click)="CreateupdateServiceActivity('new')"
                                                            *ngIf="fp.masterserviceactivitycreate"
                                                            [disabled]="global.globalAgencyId == '00000000-0000-0000-0000-000000000000'">Add
                                                            ServiceActivity</button>&nbsp;
                                                    </div>
                                                    <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 ml-0">
                                                    </div>
                                                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4  mt-1 ">
                                                        <button type="button" class="btn blue-btn btn-sm"
                                                            (click)="RefreshServiceActivity()"
                                                            [disabled]="global.globalAgencyId == '00000000-0000-0000-0000-000000000000'">
                                                            <i class="fa fa-repeat"> </i>Refresh
                                                        </button>
                                                    </div>
                                                </div>
                                                <hr>
                                                <div style="width: 100%;">
                                                    <div *ngIf="global.globalAgencyId=='00000000-0000-0000-0000-000000000000'"
                                                        class="text-center text-danger center-block">
                                                        <label class="font-red"><i
                                                                class="fa fa-info-circle fa-lg"></i>&nbsp;Select agency
                                                            to
                                                            view details</label>
                                                    </div>
                                                    <ejs-grid #gridserviceactivity
                                                        [dataSource]='GridDataList | async'
                                                        [allowResizing]='true'  
                                                        [allowSorting]='true' allowPaging='true' [allowFiltering]='true'
                                                        [pageSettings]='initialPage' [filterSettings]='filterOptions'
                                                        (dataStateChange)='dataStateChange2($event)'
                                                        (actionBegin)="onActionComplete2($event)"
                                                        [showColumnChooser]='true'
                                                        (resizeStop)="onResizeServiceActivity($event)">
                                                        <e-columns>
                                                            <e-column minWidth=100 headerText="Actions" uid="action"
                                                                textAlign="center" [showInColumnChooser]='false'>
                                                                <ng-template #template let-data>
                                                                    <button class="btn btn-edit-table"
                                                                        data-bs-toggle="modal"
                                                                        *ngIf="fp.masterserviceactivityupdate"
                                                                        data-bs-target="#ServiceActivitymodal"
                                                                        (click)="CreateupdateServiceActivity('edit');selectServiceActivityDetails(data)"><i
                                                                            class="fa fa-edit"></i></button>&nbsp;
                                                                </ng-template>
                                                            </e-column>
                                                            <!-- <e-column minWidth=100 field="masterServiceName"
                                                            headerText="Service" type="string">
                                                            <ng-template #filterTemplate let-data>
                                                                <ejs-maskedtextbox placeholder="Enter the value">
                                                                </ejs-maskedtextbox>
                                                            </ng-template>
                                                        </e-column> -->
                                                            <e-column minWidth=100 field="serviceGroupName"
                                                                headerText="Service Group" type="string">
                                                                <ng-template #filterTemplate let-data>
                                                                    <ejs-maskedtextbox placeholder="Enter the value">
                                                                    </ejs-maskedtextbox>
                                                                </ng-template>
                                                            </e-column>

                                                            <e-column width="50" [showInColumnChooser]='false'>
                                                                <ng-template #headerTemplate let-data>
                                                                    <div class="d-none d-lg-block">
                                                                        <span id='show' (click)='showserviceact()'><i
                                                                                class="fa fa-cog fa-lg"
                                                                                aria-hidden="true">
                                                                            </i></span>
                                                                    </div>
                                                                </ng-template>
                                                            </e-column>
                                                        </e-columns>
                                                    </ejs-grid>
                                                    <div *ngIf="ServiceDataActivityList.length == 0  &&  global.globalAgencyId!='00000000-0000-0000-0000-000000000000'"
                                                        class="text-center" style="color:red">
                                                        <p>No data available</p>
                                                    </div>
                                                </div>
                                            </div>
                                         
                                         
                                        </div>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </div>

</div>
<!-- ======================================Service Group Add and update Modal===================================== -->
<span id="openModal3" data-bs-target="#ServiceGroupmodal" data-bs-toggle="modal"></span>
<div class="modal fade" id="ServiceGroupmodal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"
    data-bs-backdrop="static">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel"><span *ngIf="ModalType =='new'"> Create
                        Service Group</span> <span *ngIf="ModalType =='edit'">Update Service Group</span> </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"></span>
                </button>
            </div>
            <div class="modal-body ">
                <form [formGroup]="ServiceGroupForm">
                    <div class="row">
                        <div class="col-lg-3">
                            <label>Name<span class="super-script">*</span></label>
                        </div>
                        <div class="col-lg-9">
                            <input type="text" class="form-control" formControlName="Name" id="SGname"
                                [(ngModel)]="ServiceGroup.name" (change)="checkpopServiceGroup()">
                        </div>
                    </div>
                    <span class="help-block text-danger text-center"
                        *ngIf="!ServiceGroupForm.get('Name').valid && ServiceGroupForm.get('Name').touched ">
                        <p>Please Enter Group</p>
                    </span>
                    <div class="row">
                        <div class="col-lg-3">
                            <label>Default Service<span class="super-script">*</span></label>
                        </div>
                        <div class="col-lg-9">
                            <ng-select formControlName="DefaultService"
                                [(ngModel)]="ServiceGroup.defaultMasterServiceId" [searchable]="true" [clearable]="true"
                                [items]="defaultServicesDropdown1" bindLabel="Value" bindValue="Key"  id="SGdefaultservice"
                                (change)="checkpopServiceGroup()" groupBy="type">
                                <ng-template ng-optgroup-tmp let-item="item">
                                    {{item.type}}
                                </ng-template>
                            </ng-select>

                        </div>
                    </div>
                    <span class="help-block text-danger text-center"
                        *ngIf="!ServiceGroupForm.get('DefaultService').valid && ServiceGroupForm.get('DefaultService').touched ">
                        <p>Please Enter Service</p>
                    </span>
                </form>
            </div>
            <div class="modal-footer">
                <button class="btn blue-btn btn-sm" [disabled]="!ServiceGroupForm.valid || isSaveorUpdateBoolean" id="saveServiceGroup"
                    (click)="SaveOrUpdateServiceGroup(ServiceGroup)"><span *ngIf="ModalType =='new'"> Save &
                        Close</span> <span *ngIf="ModalType =='edit'">Update & Close</span> </button>
                <button type="button" class="btn blue-btn btn-sm" (click)="openDialogServiceGroup()" id="closeServiceGroup">Close</button>
            </div>
        </div>
    </div>
</div>


<!-- ======================================ServicePaylocitymodal Add and update Modal===================================== -->
<span id="openModal31" data-bs-target="#ServicePaylocitymodal" data-bs-toggle="modal"></span>
<div class="modal fade" id="ServicePaylocitymodal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"
    data-bs-backdrop="static">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel"><span *ngIf="ModalType =='new'"> Create
                        Service Paylocity</span> <span *ngIf="ModalType =='edit'">Update Service Paylocity</span> </h5>
                <button type="button" class="btn-close"(click)="ServicePaylocityClear()" aria-label="Close">
                    <span aria-hidden="true"></span>
                </button>
            </div>
            <div class="modal-body ">
                <div class="container">
                    <form [formGroup]="PaylocityForm">
                        <div class="row">
                            <div class="col-lg-3">
                                <label>Name<span class="super-script">*</span></label>
                            </div>
                            <div class="col-lg-9">
                                <input type="text" class="form-control" formControlName="Name"
                                    [(ngModel)]="paylocity.paylocityName" (change)="checkpopServicePaylocity()">
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-3">
                                <label>Service<span class="super-script">*</span></label>
                            </div>
                            <div class="col-lg-9">
                                <ng-select formControlName="DefaultService" [(ngModel)]="paylocity.masterServiceId"
                                    [searchable]="true" [clearable]="true" [items]="defaultServicesDropdown1"
                                    bindLabel="Value" bindValue="Key" groupBy="type">
                                    <ng-template ng-optgroup-tmp let-item="item" (change)="checkpopServicePaylocity()">
                                        {{item.type}}
                                    </ng-template>
                                </ng-select>
                            </div>
                        </div>

                    </form>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn blue-btn btn-sm" [disabled]="!PaylocityForm.valid || isSaveorUpdateBoolean"
                    (click)="SaveOrUpdateServicePaylocity()"><span *ngIf="ModalType =='new'"> Save &
                        Close</span> <span *ngIf="ModalType =='edit'">Update & Close</span> </button>
                <button type="button" class="btn blue-btn btn-sm" (click)="openDialogServicePaylocity()">Close</button>
            </div>
        </div>
    </div>
</div>


<!-- ======================================GroupServiceMapModal Add and update Modal===================================== -->
<span id="openModal32" data-bs-target="#GroupServiceMapModal" data-bs-toggle="modal"></span>
<div class="modal fade" id="GroupServiceMapModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel"><span *ngIf="ModalType =='new'">Create
                        ServiceGroup Mapping</span> <span *ngIf="ModalType =='edit'">Update ServiceGroup Mapping</span>
                </h5>
                <button type="button" class="btn-close" aria-label="Close" (click)="ClearServiceGroupMappingModal()">
                    <span aria-hidden="true"></span>
                </button>
            </div>
            <div class="modal-body ">
                <form [formGroup]="ServiceGroupMappingForm">
                    <div class="row">
                        <div class="col-lg-3">
                            <label>Group<span class="super-script">*</span></label>
                        </div>
                        <div class="col-lg-9 d-flex">
                            <ng-select class="w-100" formControlName="GroupName" id="GroupNamemapping"
                                [(ngModel)]="ServiceGroupMapping.serviceGroupId" (change)="checkpopServiceGRPMap()">
                                <ng-option [value]=i.id *ngFor="let i of ServiceGroupDrop">{{i.name}}
                                </ng-option>
                            </ng-select>
                            <app-dropdown (EmitRefreshClick)="refreshtoGetDropdownValues('Service_Group')"></app-dropdown>
                        </div>
                    </div>
                    <span class="help-block text-danger text-center"
                        *ngIf="!ServiceGroupMappingForm.get('GroupName').valid && ServiceGroupMappingForm.get('GroupName').touched ">
                        <p>Please Enter Group</p>
                    </span>
                    <div class="row">
                        <div class="col-lg-3">
                            <label>Service<span *ngIf="ModalType =='new'" class="super-script">*</span></label>
                        </div>
                        <div class="col-lg-9">
                            <ng-select class="w-100" [multiple]="true" formControlName="ServiceGroupMapping"  id="Servicegroupmappingservice"
                                [(ngModel)]="ServiceGroupMapping.masterServiceId" [searchable]="true" [clearable]="true"
                                [items]="defaultServicesDropdown1" bindLabel="Value" bindValue="Key" groupBy="type"
                                (change)="checkpopServicePaylocity()">
                                <ng-template ng-optgroup-tmp let-item="item">
                                    {{item.type}}
                                </ng-template>
                            </ng-select>
                            <!-- <ng-select formControlName="ServiceGroupMapping"
                                [(ngModel)]="ServiceGroupMapping.masterServiceId" [searchable]="true" [clearable]="true"
                                [items]="defaultServicesDropdown1" bindLabel="Value" bindValue="Key" groupBy="type"
                                (change)="checkpopServicePaylocity()">
                                <ng-template ng-optgroup-tmp let-item="item">
                                    {{item.type}}
                                </ng-template>
                            </ng-select> -->

                        </div>
                    </div>
                    <span class="help-block text-danger text-center"
                        *ngIf="!ServiceGroupMappingForm.get('ServiceGroupMapping').valid && ServiceGroupMappingForm.get('ServiceGroupMapping').touched && ModalType =='new'">
                        <p>Please Enter Service</p>
                    </span>
                </form>
            </div>
            <div class="modal-footer">
                <button class="btn blue-btn btn-sm" *ngIf="ModalType =='new'"
                    [disabled]="!ServiceGroupMappingForm.valid || isSaveorUpdateBoolean"
                    (click)="SaveOrUpdateServiceGrpMap(ServiceGroupMapping)" id="SaveServiceGrpMap">Save &
                    Close</button>
                <button class="btn blue-btn btn-sm" *ngIf="ModalType =='edit'" [disabled]=" isSaveorUpdateBoolean|| ServiceGroupMapping.serviceGroupId == null ||
                        ServiceGroupMapping.serviceGroupId == ''|| ServiceGroupMapping.serviceGroupId == undefined"
                    (click)="SaveOrUpdateServiceGrpMap(ServiceGroupMapping)" id="UpdateServiceGrpMap">
                    Update & Close</button>
                <button type="button" class="btn blue-btn btn-sm" (click)="openDialogServiceGrpMap()" id="openDialogServiceGrpMap">Close</button>
            </div>
        </div>
    </div>
</div>

<!-- ======================================Service Add and update Modal===================================== -->
<span id="openModal" data-bs-target="#modal" data-bs-toggle="modal"></span>
<div class="modal fade" id="modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true"
    data-bs-backdrop="static">
    <div class="modal-dialog  modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel"><span *ngIf="ModalType =='new'"> Create
                        Service</span> <span *ngIf="ModalType =='edit'">Update Service</span> </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"></span>
                </button>
            </div>
            <div class="modal-body">
                <form [formGroup]="ServiceForm">
                    <div class="row">
                        <div class="col-lg-6">
                            <label>Code<span class="super-script">*</span></label>
                        </div>
                        <div class="col-lg-6">
                            <input type="text" class="form-control" formControlName="Code" id="servicecode"
                                [(ngModel)]="Service.masterServiceCode" (keypress)="checkalnum($event);"
                                (ngModelChange)="checkpopupService('Code')">
                        </div>
                    </div>
                    <span class="help-block text-danger text-center"
                        *ngIf="!ServiceForm.get('Code').valid && ServiceForm.get('Code').touched">
                        <p>Please Enter Code</p>
                    </span>
                    <div class="row">
                        <div class="col-lg-6">
                            <label>Modifier 1</label>
                        </div>
                        <div class="col-lg-6">
                            <input type="text" class="form-control" formControlName="Modifier1" id="servicemod1"
                                [(ngModel)]="Service.masterServiceModifier1"
                                (ngModelChange)="checkpopupService('Modifier1')">
                        </div>
                    </div>
                    <!-- <span class="help-block text-danger text-center"
                    *ngIf="!ServiceForm.get('Modifier1').valid && ServiceForm.get('Modifier1').touched">
                    <p>Please Enter Modifier1</p>
                    </span> -->
                    <div class="row">
                        <div class="col-lg-6">
                            <label>Modifier 2</label>
                        </div>
                        <div class="col-lg-6">
                            <input type="text" class="form-control" formControlName="Modifier2" id="servicemod2"
                                [(ngModel)]="Service.masterServiceModifier2"
                                (ngModelChange)="checkpopupService('Modifier2')">
                        </div>
                    </div>
                    <!-- <span class="help-block text-danger text-center"
                    *ngIf="!ServiceForm.get('Modifier2').valid && ServiceForm.get('Modifier2').touched">
                    <p>Please Enter Modifier2</p>
                    </span> -->
                    <div class="row">
                        <div class="col-lg-6">
                            <label>Modifier 3</label>
                        </div>
                        <div class="col-lg-6">
                            <input type="text" class="form-control" formControlName="Modifier3" id="servicemod3"
                                [(ngModel)]="Service.masterServiceModifier3"
                                (ngModelChange)="checkpopupService('Modifier3')">
                        </div>
                    </div>
                    <!-- <span class="help-block text-danger text-center"
                    *ngIf="!ServiceForm.get('Modifier3').valid && ServiceForm.get('Modifier3').touched">
                    <p>Please Enter Modifier3</p>
                    </span> -->
                    <div class="row">
                        <div class="col-lg-6">
                            <label>Modifier 4</label>
                        </div>
                        <div class="col-lg-6">
                            <input type="text" class="form-control" formControlName="Modifier4" id="servicemod4"
                                [(ngModel)]="Service.masterServiceModifier4"
                                (ngModelChange)="checkpopupService('Modifier4')">
                        </div>
                    </div>


                    <!-- <span class="help-block text-danger text-center"
                    *ngIf="!ServiceForm.get('Modifier4').valid && ServiceForm.get('Modifier4').touched">
                    <p>Please Enter Modifier4</p>
                    </span> -->
                    <div class="row">
                        <div class="col-lg-6">
                            <label>Name<span class="super-script">*</span></label>
                        </div>
                        <div class="col-lg-6">
                            <input type="text" class="form-control" formControlName="Name" id="servicename"
                                [(ngModel)]="Service.masterServiceName" (ngModelChange)="checkpopupService('Name')">
                        </div>
                    </div>
                    <span class="help-block text-danger text-center"
                        *ngIf="!ServiceForm.get('Name').valid && ServiceForm.get('Name').touched">
                        <p>Please Enter Name</p>
                    </span>
                    <div class="row">
                        <div class="col-lg-6">
                            <label>Description<span class="super-script">*</span></label>
                        </div>
                        <div class="col-lg-6">
                            <input type="text" class="form-control" formControlName="Description" id="servicedecscribe"
                                [(ngModel)]="Service.serviceDescription"
                                (ngModelChange)="checkpopupService('Description')">
                        </div>
                    </div>
                    <span class="help-block text-danger text-center"
                        *ngIf="!ServiceForm.get('Description').valid && ServiceForm.get('Description').touched">
                        <p>Please Enter Description</p>
                    </span>
                    <div class="row">
                        <div class="col-lg-6">
                            <label>Status<span class="super-script">*</span></label>
                        </div>
                        <div class="col-lg-6 d-flex">
                            <select style="font-weight: 600;" class="form-control" formControlName="Status" id="servicestatusLid"
                                [(ngModel)]="Service.statusLid" (ngModelChange)="checkpopupService('Status')">
                                <option></option>
                                <option [value]=i.id *ngFor="let i of StatusList">{{i.lovName}}</option>
                            </select>
                            <app-dropdown (EmitRefreshClick)="refreshtoGetDropdownValues('STATUS')"></app-dropdown>
                        </div>
                    </div>
                    <span class="help-block text-danger text-center"
                        *ngIf="!ServiceForm.get('Status').valid && ServiceForm.get('Status').touched">
                        <p>Please Enter Status</p>
                    </span>
                    <div class="row">
                        <div class="col-lg-6">
                            <label>Ratio<span class="super-script">*</span></label>
                        </div>
                        <div class="col-lg-6">
                            <input type="string" class="form-control" formControlName="Ratio" id="serviceratio"
                                (keypress)="keypress($event)" maxlength="2" [(ngModel)]="Service.ratio"
                                (ngModelChange)="checkpopupService('Ratio')">
                        </div>
                    </div>
                    <span class="help-block text-danger text-center"
                        *ngIf="!ServiceForm.get('Ratio').valid && ServiceForm.get('Ratio').touched">
                        <p>Please Enter Ratio</p>
                    </span>
                    <div class="row">
                        <div class="col-lg-6">
                            <label>Net Rate<span class="super-script">*</span></label>
                        </div>
                        <div class="col-lg-6">
                            <input type="number" class="form-control" [(ngModel)]="Service.netRate" id="servicenetrate"
                                formControlName="NetRate" (ngModelChange)="checkpopupService('NetRate')">
                            <span class="help-block text-danger text-center"
                                *ngIf="!ServiceForm.get('NetRate').valid && ServiceForm.get('NetRate').touched ">
                                <p>Please Enter Net Rate</p>
                            </span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6">
                            <label>U/C Rate<span class="super-script">*</span></label>
                        </div>
                        <div class="col-lg-6">
                            <input type="number" class="form-control" [(ngModel)]="Service.unitrate" id="ucrate"
                                formControlName="UnitRate" (ngModelChange)="checkpopupService('UnitRate')">

                            <span class="help-block text-danger text-center"
                                *ngIf="!ServiceForm.get('UnitRate').valid && ServiceForm.get('UnitRate').touched ">
                                <p>Please Enter Unit Rate</p>
                            </span>
                        </div>
                    </div>


                    <div class="row">
                        <div class="col-lg-6">
                            <label><span>is837I</span></label>
                        </div>
                        <div class="col-lg-6">
                            <input type="checkbox"  formControlName="is837I" id="is837Iservice"
                                [(ngModel)]="Service.is837I" (ngModelChange)="checkpopupService('is837I')">
                        </div>
                    </div>
                    <!-- <div class="row">
                        <div class="col-lg-6">
                            <label><span>ServiceType</span></label>
                        </div>
                        <div class="col-lg-6 d-flex">
                      
                                <select style="font-weight: 600;" class="form-control" formControlName="isHousing" id="ServiceType"
                                [(ngModel)]="Service.serviceTypeLid" (ngModelChange)="checkpopupService('isHousing')">
                                <option [value]=i.Key *ngFor="let i of global.serviceType">{{i.Value}}</option>
                            </select>
                            <app-dropdown (EmitRefreshClick)="refreshtoGetDropdownValues('SERVICETYPE')"></app-dropdown>

                        </div>
                    </div> -->

                </form>
            </div>
            <div class="modal-footer">
                <button class="btn blue-btn btn-sm" [disabled]="!ServiceForm.valid || isSaveorUpdateBoolean" id="SaveOrUpdateService"
                    (click)="SaveOrUpdateService()"><span *ngIf="ModalType =='new'"> Save &
                        Close</span> <span *ngIf="ModalType =='edit'">Update & Close</span> </button>
                <button type="button" class="btn blue-btn btn-sm" (click)="openDialogService()" id="openDialogService">Close</button>
            </div>
        </div>
    </div>
</div>

<!-- ===================================================Activity Add & Update Form============================= -->
<span id="openModal1" data-bs-target="#Activitymodal" data-bs-toggle="modal"></span>
<div class="modal fade" id="Activitymodal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog create-update-zip" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel"><span *ngIf="ModalType =='new'"> Create
                        Activity</span> <span *ngIf="ModalType =='edit'">Update Activity</span> </h5>
                <button type="button" class="btn-close"data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"></span>
                </button>
            </div>
            <div class="modal-body">
                <form [formGroup]="ActivityForm">
                    <div class="row">
                        <div class="col-lg-6">
                            <label>Code<span class="super-script">*</span></label>
                        </div>
                        <div class="col-lg-6">
                            <input type="text" class="form-control" formControlName="Code"
                            id="ActivityCode"
                                [(ngModel)]="Activity.masterActivityCode" (change)="checkpopActivity()">
                        </div>
                    </div>
                    <span class="help-block text-danger text-center"
                        *ngIf="!ActivityForm.get('Code').valid && ActivityForm.get('Code').touched">
                        <p>Please Enter Code</p>
                    </span>
                    <div class="row">
                        <div class="col-lg-6">
                            <label>Name<span class="super-script">*</span></label>
                        </div>
                        <div class="col-lg-6">
                            <input type="text" class="form-control" formControlName="Name"
                            id="ActivityName"
                                [(ngModel)]="Activity.masterActivityName" (change)="checkpopActivity()">
                        </div>
                    </div>
                    <span class="help-block text-danger text-center"
                        *ngIf="!ActivityForm.get('Name').valid && ActivityForm.get('Name').touched">
                        <p>Please Enter Name</p>
                    </span>
                    <div class="row">
                        <div class="col-lg-6">
                            <label>Status<span class="super-script">*</span></label>
                        </div>
                        <div class="col-lg-6 d-flex">
                            <select style="font-weight: 600;" class="form-control" formControlName="Status"
                                [(ngModel)]="Activity.statusLid" (change)="checkpopActivity()" 
                                id="ActivityStatus">
                                <option [value]=i.id *ngFor="let i of StatusList">{{i.lovName}}</option>
                            </select>
                            <app-dropdown (EmitRefreshClick)="refreshtoGetDropdownValues('STATUS')"></app-dropdown>
                        </div>
                    </div>
                    <span class="help-block text-danger text-center"
                        *ngIf="!ActivityForm.get('Status').valid && ActivityForm.get('Status').touched">
                        <p>Please Enter Status</p>
                    </span>
                </form>
            </div>
            <div class="modal-footer">
                <button class="btn blue-btn btn-sm" [disabled]="!ActivityForm.valid || isSaveorUpdateBoolean"
                    (click)="SaveOrUpdateActivity()" id="ActivitySaveorUpdate"><span *ngIf="ModalType =='new'"> Save &
                        Close</span> <span *ngIf="ModalType =='edit'">Update & Close</span> </button>
                <button type="button" class="btn blue-btn btn-sm" (click)="openDialogActivity()" id="ActivityClose">Close</button>
            </div>
        </div>
    </div>
</div>

<!-- ===================================================ServiceActivity Add & Update Form============================= -->
<span id="openModal2" data-bs-target="#ServiceActivitymodal" data-bs-toggle="modal"></span>
<div class="modal fade" id="ServiceActivitymodal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel"><span *ngIf="ModalType =='new'"> Create
                        ServiceActivity</span> <span *ngIf="ModalType =='edit'">Update ServiceActivity</span> </h5>
                <button type="button" class="btn-close"data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"></span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-4">
                        <label>Service Type</label>
                    </div>
                    <div class="col-lg-8 d-flex">
                        <ng-select class="w-100" [(ngModel)]="ServiceActivityArray1.masterServiceId"
                        id="Tab4ActivityServiceType"
                            (ngModelChange)="getActivityTypeSatus(ServiceActivityArray1.masterServiceId)"
                            [clearable]="true" [searchable]="true" [items]="ServiceActivityArray" bindLabel="label"
                            bindValue="value">
                            <!-- <option *ngFor="let service of ServiceActivityArray" [value]="service.value">{{service.label}}</option> -->
                        </ng-select>
                        <app-dropdown (EmitRefreshClick)="refreshtoGetDropdownValues('Service_Dropdown')"></app-dropdown>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6">
                        <div class="example-container">
                            <label>Available Activities</label>
                            <div cdkDropList #doneList="cdkDropList" class="example-list"
                            id="Tab4AvailableActivities"
                                [cdkDropListData]="availableActivities"
                                (cdkDropListDropped)="drop($event);checkpopServiceActivity()"
                                [cdkDropListConnectedTo]="[todoList]">
                                <div *ngIf="availableActivities.length == 0 && ModalType == 'new'">
                                    <p>Select service to view activities</p>
                                </div>
                                <div *ngIf="availableActivities.length == 0 && ModalType == 'edit'">
                                    <p>No data available!</p>
                                </div>
                                <div *ngIf="availableActivities.length != 0">
                                    <div class="example-box" *ngFor="let item of availableActivities" cdkDrag>
                                        {{ item.Value }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="example-container">
                            <label>Selected Activities</label>
                            <div cdkDropList #todoList="cdkDropList" [cdkDropListData]="selectedActivities"
                            id="Tab4SelectedActivities"
                                [cdkDropListConnectedTo]="[doneList]" class="example-list"
                                (cdkDropListDropped)="drop($event);checkpopServiceActivity()">
                                <div *ngIf="selectedActivities.length == 0">
                                    <p>No data available!</p>
                                </div>
                                <div *ngIf="selectedActivities.length != 0">
                                    <div class="example-box" *ngFor="let item of selectedActivities" cdkDrag>
                                        {{ item.Value }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn blue-btn btn-sm"  [disabled]='isSaveorUpdateBoolean'
                (click)="SaveOrUpdateServiceActivity(ServiceActivityArray1)"><span
                        *ngIf="ModalType =='new'"> Save &
                        Close</span> <span *ngIf="ModalType =='edit'">Update & Close</span> </button>
                <button type="button" class="btn blue-btn btn-sm" (click)="openDialogServiceActivity()">Close</button>
            </div>
        </div>
    </div>
</div>

<!-- =====================================Delete ServiceGroup Confirmation Modal============================== -->
<span id="deleteServiceGroupmodalOpen" data-bs-toggle="modal" data-bs-target="#deleteServiceGroupmodal"></span>
<div class="modal fade" id="deleteServiceGroupmodal" data-bs-backdrop="static" data-bs-toggle="modal">
    <div class="modal-dialog delete-zip" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">Delete Record</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"></span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12">
                        <label>Do you want to delete this record ?</label>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="deleteServiceGroup()">Delete</button>
                <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">Cancel</button>
            </div>
        </div>
    </div>
</div>

<!-- =====================================Delete Status Confirmation Modal============================== -->
<span id="deleteservicemodal" data-bs-toggle="modal" data-bs-target="#deleteStatusmodal"></span>
<div class="modal fade" id="deleteStatusmodal" data-bs-backdrop="static" data-bs-toggle="modal">
    <div class="modal-dialog delete-zip" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">Delete Record</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"></span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12">
                        <label>Do you want to delete this record ?</label>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="deleteStatus()">Delete</button>
                <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">Cancel</button>
            </div>
        </div>
    </div>
</div>

<!-- =====================================Delete Activity Confirmation Modal============================== -->
<span id="closedeleteactivity" data-bs-toggle="modal" data-bs-target="#deleteActivitymodal"></span>
<div class="modal fade" id="deleteActivitymodal" data-bs-backdrop="static">
    <div class="modal-dialog delete-zip" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">Delete Record</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"></span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12">
                        <label>Do you want to delete this record ?</label>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="deleteActivity()">Delete</button>
                <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">Cancel</button>
            </div>
        </div>
    </div>
</div>

<!-- =====================================Delete paylocity Confirmation Modal============================== -->
<span id="closedeletepaylocity" data-bs-toggle="modal" data-bs-target="#deletePaylocitymodal"></span>
<div class="modal fade" id="deletePaylocitymodal" data-bs-backdrop="static">
    <div class="modal-dialog delete-zip" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">Delete Record</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"></span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12">
                        <label>Do you want to delete this record ?</label>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="deletePaylocity()">Delete</button>
                <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">Cancel</button>
            </div>
        </div>
    </div>
</div>

<!-- =====================================Delete ServiceGroup Mapping  Modal============================== -->
<span id="closedeleteServiceGroupMapping" data-bs-toggle="modal" data-bs-target="#deleteSVCGRPmodal"></span>
<div class="modal fade" id="deleteSVCGRPmodal" data-bs-backdrop="static">
    <div class="modal-dialog delete-zip" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">Delete Record</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"></span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12">
                        <label>Do you want to delete this record ?</label>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="deleteSVCGRP()">Delete</button>
                <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">Cancel</button>
            </div>
        </div>
    </div>
</div>

<!-- ==============close without save modal================================= -->
<span id="cancelmodal" data-bs-toggle="modal" data-bs-target="#CloseModal"></span>
<div class="modal fade primarymodal" id="CloseModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog create-update-zip" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">Close</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"></span>
                </button>
            </div>
            <div class="modal-body">
                You want to close without saving?
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="closeAddUpdateModal()">Yes</button>
                <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">No</button>
            </div>
        </div>

    </div>
</div>

<!----------------------------------------------Assign QP Services Modal---------------------------------------------------->
<span id="OpenAssignQpModel" data-bs-target="#AssignQPmodal" data-bs-toggle="modal"></span>
<div class="modal fade" id="AssignQPmodal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"
    data-bs-backdrop="static">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">
                    QP Services </h5>
                <button type="button" class="btn-close"data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"></span>
                </button>
            </div>
            <div class="modal-body">
                <form [formGroup]="QPServiceForm">
                    <div class="row">
                        <div class="col-lg-4">
                            <label>QP Services<span class="super-script">*</span></label>
                        </div>
                        <div class="col-lg-8">
                            <ng-select class="w-100" [multiple]="true" formControlName="services"
                                [(ngModel)]="QpServicesList.masterServiceId" [searchable]="true" [clearable]="true"
                                [items]="defaultServicesDropdown1" bindLabel="Value" bindValue="Key" groupBy="type"
                                (change)="checkAssignQpServicePaylocal()">
                                <ng-template ng-optgroup-tmp let-item="item">
                                    {{item.type}}
                                </ng-template>
                            </ng-select>
                        </div>
                    </div>
                    <span class="help-block text-danger text-center"
                        *ngIf="!QPServiceForm.get('services').valid && QPServiceForm.get('services').touched ">
                        <p>Please Enter Service</p>
                    </span>
                </form>
            </div>
            <div class="modal-footer">
                <button class="btn blue-btn btn-sm" [disabled]="!QPServiceForm.valid || isSaveorUpdateBoolean" (click)="SaveQpService()">
                    <!-- <span *ngIf="ModalType =='new'"> -->
                    Save & Close
                    <!-- </span>  -->
                    <!-- <span *ngIf="ModalType =='edit'">
                        Update & Close
                    </span>  -->
                </button>
                <button type="button" class="btn blue-btn btn-sm" (click)="closeQPService()">Close</button>
            </div>
        </div>
    </div>
</div>



<!-- ======================================Service Add and update Modal===================================== -->
<span id="openErrorModal" data-bs-target="#ErrorModal" data-bs-toggle="modal"></span>
<div class="modal fade" id="ErrorModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog create-update-zip" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">Error </h5>
                <button type="button" class="btn-close" (click)="closeErrormodal()" aria-label="Close">
                    <span aria-hidden="true"></span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row" *ngFor="let n of  ErrorList">
                    <div class="col-12">
                        <label>{{n}}</label>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="closeErrormodal()">Close</button>
            </div>
        </div>
    </div>
</div>